export const links = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Explore",
    href: "/explore",
  },
  {
    title: "Notifications",
    href: "/notifications",
  },
  {
    title: "Bookmarks",
    href: "/bookmarks",
  },
  {
    title: "Journey",
    href: "",  // Will be dynamically set to /${username}
  },
];

export const linksMobile = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Search",
    href: "/explore",
  },
  {
    title: "Chatbot",
    href: "/chatbot",
  },
  {
    title: "Communities",
    href: "/communities",
  },
  {
    title: "Membership",
    href: "/memberships",
  },
  {
    title: "Marketplace",
    href: "/marketplace",
  },
];

export const mobileSidebarLinks = [
  {
    title: "Journey",
    href: "",  // Will be dynamically set to /${username}
  },
  {
    title: "Notifications",
    href: "/notifications",
  },
  {
    title: "Challenges",
    href: "/challenges",
  },
  {
    title: "Leaderboard",
    href: "/leaderboard",
  },
  {
    title: "Bookmarks",
    href: "/bookmarks",
  },
  {
    title: "Calendars",
    href: "/calendars",
  },
  {
    title: "Map",
    href: "/map",
  },
  {
    title: "Transactions",
    href: "/transactions",
  },
  {
    title: "Events",
    href: "/events",
  },
  {
    title: "Trials",
    href: "/trials",
  },
  {
    title: "Jobs",
    href: "/jobs",
  },
  {
    title: "Consultations",
    href: "/consultations",
  },
  {
    title: "Genomics",
    href: "/genomics",
  },
  {
    title: "Nutrition",
    href: "/nutrition",
  },
];